import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import { setPersonalInformation } from '../../GraphQL/mutation/AddPersonalInformation';

import AddPersonalInformation from '../../Components/AddPersonalInformation';

class AddPersonalInformationGQL extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
  };
  render() {
    const { onClickUpdatedUserProfile } = this.props;
    return (
      <Mutation mutation={setPersonalInformation}>
        {setPersonalInfo => (
          <AddPersonalInformation
            mutation={setPersonalInfo}
            onUpdatedUserProfile={onClickUpdatedUserProfile}
          />
        )}
      </Mutation>
    );
  }
}

export default AddPersonalInformationGQL;
